export default __webpack_public_path__ + "static/media/section78_background.066f835c.svg";